export default "__VITE_ASSET__BePW7mcG__"